var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-transporte","rota-base":"/admin/tipo-transporte","titulo-singular":"Meio de Transporte","campos-extras":[
        { campo: "cod_censo", label: "Código Censo (INEP)", span: 12 }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }